import React from 'react';
import { useTranslation } from 'react-i18next';
import SimpleButton from '@/components/UI/SimpleButton/SimpleButton';

const OPEN_FILTER_TRANSLATION_KEY = 'openFilter';

type LateralFilterButtonParams = {
  filterParams?: {
    setOverviewFiltersFocus?: (field: string) => void;
    field?: string;
    buttonText?: string;
  };
};

const LateralFilterButton: React.FC<LateralFilterButtonParams> = ({ filterParams = {} }) => {
  const { t } = useTranslation();
  const { setOverviewFiltersFocus, field, buttonText } = filterParams;

  return (
    <SimpleButton
      id={`filter-lateral-${field}`}
      color="primary"
      buttonText={buttonText || t(OPEN_FILTER_TRANSLATION_KEY)}
      handleClick={() => setOverviewFiltersFocus?.(field || '')}
      buttonClassName="w-100"
    />
  );
};

export default LateralFilterButton;
